/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const PaneHeader = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  padding-bottom: 24px;

  & button {
    position: absolute;
    right: 0;
    top: 0;
  }
`;

export const PaneTitle = styled.div`
  color: ${Palette.PrimaryGray._700};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;

export const NoteText = styled.div`
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const PaneFooter = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  align-items: center;
  padding-top: 16px;
`;

export const EditorRoot = styled.div`
  border: 1px solid ${Palette.PrimaryGray._200};
  border-radius: 4px;
`;

export const EditorHeader = styled.div`
  padding: 4px;
  display: flex;
  gap: 16px;
`;

export const Editor = styled.div`
  border-top: 1px solid ${Palette.PrimaryGray._200};
  background-color: ${Palette.PrimaryGray._000};
  cursor: text;
  font-size: 16px;
  min-height: 100px;
  padding: 8px;

  & [contenteditable] {
    min-height: 100px;
  }
`;

export const Button = styled.div`
  width: 24px;
  height: 24px;
  cursor: pointer;
  padding: 2px 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  border-radius: 4px;

  &:hover {
    background-color: ${Palette.PrimaryGray._000};
  }
  &:active {
    background-color: ${Palette.PrimaryGray._100};
  }
`;
